<div class="container container--approver">
  <div class="container--approver-page">
    <p class="expense-details">Expense Details</p>
    <div class="consolidate-expense-information mb-4">
      <p class="expense-information">Expense Information</p>
      <div class="flex flex-w py-2 p-20">
        <div class="row">
          <div class="col-sm-12 col-md-12">
            <div class="report-activity-item d-flex flex-wrap align-items-center mb-4">
              <div class="flex flex-w py-2 flex-column">
                <div class="list-item-label d-inline-block me-3 request-name-header">
                  Expense Date
                </div>
                <div class="list-item-content d-inline-block request-name-value">
                  <span>
                    {{ expenseDate
                    | date : "mediumDate"
                    | doubleDashForEmptyValues
                    }}
                  </span>
                </div>
              </div>

              <div class="flex flex-w py-2 flex-column">
                <div class="list-item-label d-inline-block me-3 request-name-header">
                  Expense ID
                </div>
                <div class="list-item-content d-inline-block request-name-value">
                  <span>
                    {{referenceId}}
                  </span>
                </div>
              </div>


              <div class="flex flex-w py-2 flex-column">
                <div class="list-item-label d-inline-block me-3 request-name-header">
                  Merchant
                </div>
                <div class="list-item-content d-inline-block request-name-value">
                  <span>
                    {{merchant}}
                  </span>
                </div>
              </div>


              <div class="flex flex-w py-2 flex-column">
                <div class="list-item-label d-inline-block me-3 request-name-header">
                  Amount
                </div>
                <div class="list-item-content d-inline-block request-name-value">
                  <span>
                    <app-rupee-sign-v1 [type]="'bold'"></app-rupee-sign-v1>{{amount |
                    number :
                    "1.2-2"
                    : "en-IN" |
                    doubleDashForEmptyValues}}
                  </span>

                </div>
              </div>

              <div class="flex flex-w py-2 flex-column">
                <div class="list-item-label d-inline-block me-3 request-name-header">
                  Approved Amount
                </div>
                <div class="list-item-content d-inline-block request-name-value">
                  <span>
                    <app-rupee-sign-v1 [type]="'bold'"></app-rupee-sign-v1>{{approvedAmount |
                    number :
                    "1.2-2"
                    : "en-IN" | doubleDashForEmptyValues}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    @if (showApprovalActions) {
      <div class="d-flex justify-center mt-4" style="column-gap:10px;">
            <button aria-label="expense action buttons" style="background: #FFFFFF 0% 0% no-repeat padding-box;
            border: 1px solid #36B37E;
            border-radius: 100px;
            opacity: 1;
            font: normal normal 500 14px / 19px Inter, sans-serif;
            letter-spacing: 0px;
            color: #36B37E;
            opacity: 1;
            padding: 5px 15px;" matTooltip="Approve" [matTooltipPosition]="'above'"
          matTooltipClass="material-dark-tooltip" (click)="showApproveModal('APPROVED',modelRefapproveReport)">
          <img src="../../../assets/svg/expense-mgmt/approve.svg" alt="Approve" style="width: 20px;height: 100%;">
          Approve
        </button>
            <button style="background: #FFFFFF 0% 0% no-repeat padding-box;
            border: 1px solid #ED7E71;
            border-radius: 100px;
            opacity: 1;
            font: normal normal 500 14px/19px Inter, sans-serif;
            letter-spacing: 0px;
            color: #ED7E71;
            opacity: 1;
            padding: 5px 15px;
            " aria-label="expense action buttons" matTooltip="Reject" [matTooltipPosition]="'above'"
          matTooltipClass="material-dark-tooltip" (click)="showApproveModal('REJECTED',modelRefRejectReport)">
          <img style="width: 20px;height: 100%;" src="../../../assets/svg/expense-mgmt/reject.svg" alt="Reject">
          Reject
        </button>
            <button style="background: #FFFFFF 0% 0% no-repeat padding-box;
            border: 1px solid #6554C0;
            border-radius: 100px;
            font: normal normal 500 14px / 19px Inter, sans-serif;
            letter-spacing: 0px;
            color: #6554C0;
            opacity: 1;
            padding: 5px 15px;
            opacity: 1;" aria-label="expense action buttons" (click)="showApproveModal('SENT_FOR_CORRECTION',modelRefUpdateReport)"
          matTooltip="Send for correction" [matTooltipPosition]="'above'" matTooltipClass="material-dark-tooltip">
          <img style="width: 20px;height: 100%;" src="../../../assets/svg/expense-mgmt/update.svg"
            alt="Send for correction">
          Send for Correction
        </button>
      </div>
    }

  </div>
</div>


<ng-template #modelRefRejectReport>
  <ng-container>
    <div class="model-container mx-0 my-6 p-0">
      <header class="modal-header mb-2">
        <p class="modal-title">Reject Expense</p>
        <!-- <app-close-button class="ms-auto" (onCloseEmitter)="cancelConfirm()"></app-close-button> -->
      </header>

      <div class="modal-body" style="padding:10px 25px;">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 pb-10" style="padding: 0 25px;">

            <div class="delete-instruction mt-2 mb-4">
              <img src="assets/svg/expense-mgmt/reject.svg" alt="Reject"> &nbsp;
              Are you sure you want to <strong style="color: #ec2127;">Reject</strong> the
              expense?
            </div>
            <div class="col-12 col-sm-12 col-md-12 pt-2 mx-0">
              <div class="mat-control-box">
                <form [formGroup]="form">
                  <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Comments</mat-label>

                    <input maxlength="300" formControlName="comment" matInput placeholder="Comments"
                      required name="Reason">

                    <mat-error>
                      <app-form-field-error [form]="form" [formControlRef]="form.get('comment')"
                                            [messages]="{
                                            required: 'Required',
                                            maxlength: 'More than 300 character not allowed.',
                                            pattern: 'Special characters are not allowed!'
                                          
                                          }">
                      </app-form-field-error>
                    </mat-error>
                  </mat-form-field>

                  <p class="show-info-message ms-1">
                    <img class="au-img" src="/assets/svg/star-otp.svg" alt="Remarks" />&nbsp;
                    Remarks would help you keeping the reference in future
                  </p>

                </form>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-12 col-md-12" style="padding: 0 25px;">
            <div class="d-flex justify-content-end">
              <button style="border-radius: 100px; font-weight: 600;font-size: 12px;"
                class="d-block text-center primary-color width me-4" (click)="cancelConfirm()">
                Cancel
              </button>

              <button style="border-radius: 100px;" mat-flat-button color="primary"
                [disabled]="form.invalid" [appLoaderButton]="formActionRequestState()"
                (click)="performBatchAction('REJECTED')">
                Yes, Reject
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>


<ng-template #modelRefUpdateReport>
  <ng-container>
    <div class="model-container mx-0 my-6 p-0">
      <header class="modal-header mb-2">
        <p class="modal-title">Send Expense For Correction</p>
        <!-- <app-close-button class="ms-auto" (onCloseEmitter)="cancelConfirm()"></app-close-button> -->
      </header>

      <div class="modal-body" style="padding:10px 25px;">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 pb-10" style="padding: 0 25px;">

            <div class="delete-instruction mt-2 mb-4">
              <img src="assets/svg/expense-mgmt/update.svg" alt="Reject"> &nbsp;
              Are you sure you want to <strong style="color: #5454C6;">Send For Correction</strong> the
              expense?
            </div>

            <div class="col-12 col-sm-12 col-md-12 pt-2 mx-0">
              <div class="mat-control-box">
                <form [formGroup]="form">
                  <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Comments</mat-label>

                    <input maxlength="300" formControlName="comment" matInput placeholder="Comments"
                      required name="Reason">

                    <mat-error>
                      <app-form-field-error [form]="form" [formControlRef]="form.get('comment')"
                                            [messages]="{
                                            required: 'Required',
                                            maxlength: 'More than 300 character not allowed.',
                                            pattern: 'Special characters are not allowed!'
                                          
                                          }">
                      </app-form-field-error>
                    </mat-error>
                  </mat-form-field>

                  <p class="show-info-message ms-1">
                    <img class="au-img" src="/assets/svg/star-otp.svg" alt="Remarks" />&nbsp;
                    Remarks would help you keeping the reference in future
                  </p>

                </form>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-12 col-md-12" style="padding: 0 25px;">
            <div class="d-flex justify-content-end">
              <button style="border-radius: 100px; font-weight: 600;font-size: 12px;"
                class="d-block text-center primary-color width me-4" (click)="cancelConfirm()">
                Cancel
              </button>

              <button style="border-radius: 100px;" mat-flat-button color="primary"
                [disabled]="form.invalid" [appLoaderButton]="formActionRequestState()"
                (click)="performBatchAction('SENT_FOR_CORRECTION')">
                Yes, Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>





<ng-template #modelRefapproveReport>
  <ng-container>
    <div class="model-container mx-0 my-6 p-0">
      <header class="modal-header mb-2">
        <p class="modal-title">Approve Expense</p>
        <!-- <app-close-button class="ms-auto" (onCloseEmitter)="cancelConfirm()"></app-close-button> -->
      </header>

      <div class="modal-body" style="padding:10px 25px;">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 pb-10" style="padding: 0 25px;" [formGroup]="form">

            <div class="delete-instruction mt-2 mb-4"
              style=" font: normal normal 500 12px/22px Inter, sans-serif;">
              <img src="assets/svg/expense-mgmt/approve.svg" alt="Approve"> &nbsp;
              Are you sure you want to <strong style="color: #36B37E;">Approve</strong> the
              expense?
            </div>


            <div class="col-12 col-sm-12 col-md-12 pt-2 px-0">
              <section class="d-flex justify-content-between">
                                <p class="ms-0" style="font: normal normal 500 12px/22px Inter, sans-serif !important;
                                letter-spacing: 0px !important;
                                color: #192744 !important;
                                opacity: 1 !important;">
                  <img class="au-img" src="/assets/svg/exp-rupee.svg" alt="Rupee" />&nbsp;
                  Expense Amount
                </p>
                                <p style="font: normal normal 600 12px/22px Inter, sans-serif !important;
                                letter-spacing: 0px !important;
                                color: #192744 !important;
                                opacity: 1 !important;">
                  <img class="rupee-icon" alt="Rupee"
                    src="assets/svg/rupees/input-amount-field-rupee.svg" />
                  {{
                  amount
                  | number : "1.2-2" : "en-IN"
                  | doubleDashForEmptyValues
                  }}
                </p>
              </section>
              <hr />
              <!-- <hr /> -->
              <div class="mb-2 mx-0 px-4 pb-4 ribbon-checkbox">
                <div class="mat-control-box pe-top-2" style="flex: 1;">
                  <mat-checkbox formControlName="isPartialAmount">
                    &nbsp;&nbsp;
                                        <span style="letter-spacing: 0px !important;
                                       color: #192744 !important;
                                       opacity: 1;font-weight: 500; -webkit-box-orient: vertical !important;
                                        display: -webkit-box  !important;
                                        -webkit-line-clamp: 2 !important;
                                        overflow: hidden !important ;
                                        text-overflow: ellipsis !important;
                                        white-space: normal !important;
                                        font: normal normal 500 11px / 16px Inter, sans-serif !important;
                                       ">
                      Please check, If you want to approve partial amount
                    </span>
                  </mat-checkbox>
                </div>
                <app-input-amount-field formControlName="amountToApprove" type="latest"
                  class="d-flex align-items-end" style="flex: 1;" [currency]="currency"
                placeholder="Ex: 25000"></app-input-amount-field>
              </div>
              <mat-error class="d-flex justify-end">
                <app-form-field-error [form]="form" [formControlRef]="form.get('amountToApprove')"
                                    [messages]="{
                                      required: 'Please Enter Amount',
                                      pattern: 'Invalid Amount',
                                      min: 'Minimum Amount allowed is 1'
                                    }">
                </app-form-field-error>
              </mat-error>
              <mat-error class="d-flex justify-end">
                @if (form.get('amountToApprove').hasError('max')) {
                  <span class="inline-error">
                    Maximum limit is {{ amount }}
                  </span>
                }
              </mat-error>
                            <p class="ms-0" style="font: normal normal 500 10px/15px Inter, sans-serif !important;
                                letter-spacing: 0px !important;
                                color: #858EA2 !important;
                                opacity: 1 !important;">* Partial amount should be less than to expense amount</p>


              <!-- <hr /> -->
            </div>


            <div class="col-12 col-sm-12 col-md-12 pt-2 mx-0">
              <div class="mat-control-box">

                <mat-form-field appearance="fill" class="w-full">
                  <mat-label>Comments</mat-label>

                  <input maxlength="300" formControlName="comment" matInput placeholder="Comments"
                    name="Reason">

                  <mat-error>
                    <app-form-field-error [form]="form" [formControlRef]="form.get('comment')"
                                        [messages]="{
                                            maxlength: 'More than 300 character not allowed.',
                                            pattern: 'Special characters are not allowed!'
                                          
                                          }">
                    </app-form-field-error>
                  </mat-error>
                </mat-form-field>

                <p class="show-info-message ms-1">
                  <img class="au-img" src="/assets/svg/star-otp.svg" alt="Remarks" />&nbsp;
                  Remarks would help you keeping the reference in future
                </p>


              </div>
            </div>
          </div>

          <div class="col-12 col-sm-12 col-md-12" style="padding: 0 25px;">
            <div class="d-flex justify-content-end">
              <button style="border-radius: 100px; font-weight: 600;font-size: 12px;"
                class="d-block text-center primary-color width me-4" (click)="cancelConfirm()">
                Cancel
              </button>

              <button style="border-radius: 100px;" mat-flat-button color="primary"
                [disabled]="form.invalid" [appLoaderButton]="formActionRequestState()"
                (click)="performBatchAction('APPROVED')">
                Yes, Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

</ng-template>